import React from "react";

function AuthorInfo({ formData, setFormData, index }) {
  const handleInputChange = (event) => {
    let data = [...formData["author"]];
    data[index][event.target.name] = event.target.value;
    setFormData({ ...formData, author: data });
  };

  return (
    <div className="paper-submission-container">
      <div className="paper-author-wrapper">
        <div className="paper-author-card">
          <div className="paper-author-header">
            <h1 className="paper-author-title">Author {index + 1}</h1>
            <div className="paper-author-avatar">
              <svg className="paper-author-icon" width="200" height="200" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
            <h4 className="paper-author-subtitle">Personal Information</h4>
          </div>

          {/* Personal Information */}
          <div className="paper-author-section">
            <div className="paper-author-row">
              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">First Name</span>
                  <span className="paper-required-mark">*</span>
                </label>
                <input
                  className="paper-input-field"
                  type="text"
                  placeholder="Enter first name"
                  name="firstName"
                  value={formData["author"][index]["firstName"]}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">Last Name</span>
                  <span className="paper-required-mark">*</span>
                </label>
                <input
                  className="paper-input-field"
                  type="text"
                  placeholder="Enter last name"
                  name="lastName"
                  value={formData["author"][index]["lastName"]}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="paper-author-row">
              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">Email Address</span>
                  <span className="paper-required-mark">*</span>
                </label>
                <input
                  className="paper-input-field"
                  type="email"
                  placeholder="Enter email address"
                  name="email"
                  value={formData["author"][index]["email"]}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">Affiliation</span>
                </label>
                <input
                  className="paper-input-field"
                  type="text"
                  placeholder="University/Organization"
                  name="affiliation"
                  value={formData["author"][index]["affiliation"]}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* Address Information */}
          <div className="paper-address-section">
            <div className="paper-address-header">
              <div className="paper-address-icon">
                <svg className="paper-location-icon" width="150" height="150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h4 className="paper-address-title">Address Information</h4>
            </div>

            <div className="paper-address-fields">
              <div className="paper-author-row">
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">Country</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Enter country"
                    name="country"
                    value={formData["author"][index]["country"]}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">State/Province</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Enter state or province"
                    name="state"
                    value={formData["author"][index]["state"]}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="paper-author-row">
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">City</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Enter city"
                    name="city"
                    value={formData["author"][index]["city"]}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">Postal Code</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Enter postal code"
                    name="postCode"
                    value={formData["author"][index]["postCode"]}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="paper-field-group">
                <label className="paper-field-label">
                  <span className="paper-label-text">Street Address</span>
                </label>
                <input
                  className="paper-input-field"
                  type="text"
                  placeholder="Enter street address"
                  name="street"
                  value={formData["author"][index]["street"]}
                  onChange={handleInputChange}
                />
              </div>

              <div className="paper-author-row">
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">Address Line 1</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Apartment, suite, etc."
                    name="line1"
                    value={formData["author"][index]["line1"]}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="paper-field-group paper-field-half">
                  <label className="paper-field-label">
                    <span className="paper-label-text">Address Line 2</span>
                  </label>
                  <input
                    className="paper-input-field"
                    type="text"
                    placeholder="Building, floor, etc."
                    name="line2"
                    value={formData["author"][index]["line2"]}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthorInfo;